import * as Actions from '../../../Modules/CmsActions'
import type {
  DashboardDocumentList,
  DashboardPostInfoList,
  DashboardSiteInfoList,
} from '../../../Types'

interface State {
  documentList: DashboardDocumentList[]
  siteInfoList: DashboardSiteInfoList[]
  postInfoList: DashboardPostInfoList[][]
  leadNum: number
  leadGraphList: []
  graphShow: number
}

const defaultState: State = {
  documentList: [],
  siteInfoList: [],
  postInfoList: [],
  leadNum: 0,
  leadGraphList: [],
  graphShow: 0,
}

const UIDashboardReducer = (state: State = defaultState, action) => {
  switch (action.type) {
    case Actions.GET_DOCUMENT_LIST:
      return { ...state, documentList: action.payload }

    case Actions.SERVICE_LOAD:
      return { ...state, siteInfoList: action.payload }

    case Actions.GET_POST_INFO:
      return { ...state, postInfoList: action.payload }

    case Actions.GET_LEAD_NUM:
      return { ...state, leadNum: action.payload }

    case Actions.GET_LEAD:
      return { ...state, leadGraphList: action.payload }

    case Actions.SELECT_CHANGE:
      return { ...state, graphShow: action.payload }

    case Actions.GET_POPUP_LIST:
      return { ...state, popupList: action.payload }

    default:
      return state
  }
}

export default UIDashboardReducer
